/**
 * @file 质押/解质押面板相关hooks
 */
import { useState, useEffect } from 'react';
import { FeeLevel } from '@/types/common';
import { NeedSlippageType } from '@/types/pool';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { useCoinInfoContext } from '@/hooks/useCoinInfo';
import { ethAddress, suiAddress } from '@/config/address';
import { ChainCodeTypes } from '@/types/chain';
/**
 * 滑点相关hook
 */
export const useSlippage = () => {
  const { poolInfo } = usePoolInfoContext();

  const [slippage, setSlippage] = useState(
    // 如果可以让用户滑点，默认值为0.5，否则为0并且不让用户设置滑点
    poolInfo.needSlippage === NeedSlippageType.Need ? '0.5' : ''
  );

  const onChangeSlippage = (v: string) => {
    setSlippage(v);
  };

  return {
    slippage,
    onChangeSlippage,
  };
};

/**
 * 控制gas费和滑点设置弹窗
 */
export const useSetting = () => {
  const [showSetting, setShowSetting] = useState(false);
  const [gasFeeLevel, setGasFeeLevel] = useState(FeeLevel.Middle);
  const [slippage, setSlippage] = useState('0.5');

  const onSettingConfirm = (slippage: string, gasFeeLevel?: FeeLevel) => {
    setSlippage(slippage);
    if (gasFeeLevel) {
      setGasFeeLevel(gasFeeLevel);
    }
  };

  const onChangeShowSetting = (v: boolean) => {
    setShowSetting(v);
  };

  return {
    showSetting,
    gasFeeLevel,
    slippage,
    onSettingConfirm,
    onChangeShowSetting,
  };
};

/**
 * 初始化coinInfo数据
 */
export const useInitCoinInfo = () => {
  const { poolInfo } = usePoolInfoContext();
  const { fetchCoinInfo, combindCoinInfo } = useCoinInfoContext();

  useEffect(() => {
    if (poolInfo) {
      combindCoinInfo([
        ...poolInfo.whiteList.map((item) => item),
        ...poolInfo.baseCoin.map((item) => item),
        ...poolInfo.baseStakeCoins.map((item) => item),
        ...(poolInfo.singleCoins || []).map((item) => item),
        ...(poolInfo.multipleCoins || []).map((item) => item),
      ]);
      const contractAddresses =
        poolInfo.chainCode === ChainCodeTypes.SUI ? suiAddress : ethAddress;

      fetchCoinInfo([
        {
          chainCode: poolInfo.chainCode,
          contractAddresses: [...new Set([contractAddresses])],
        },
      ]);
    }
  }, [poolInfo]);
};
